/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';

const AdditionDropDown = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || "");
    const inputRef = useRef(null); // Define a ref for the select element

    useEffect(() => {
       
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    const handleChange = (event) => {
        setValue(event.target.value);

    };

    // Required method to get the final value to be set in the grid
    useImperativeHandle(ref, () => ({
        getValue: () => value,
        isPopup: () => true,
        afterGuiAttached: () => {
            if (inputRef.current) {
                inputRef.current.focus(); // Focus on the dropdown after it's attached
            }
        }
    }));

    return (
        <select className='form-select' ref={inputRef} value={value} onChange={handleChange} style={{ width: '100%' }}>

            <option key={'0'} value={0} style={{ color: '#007bff', fontWeight: 'bold' }}>----</option>
            {props.values && props.values.map((Addition) => (
                <option key={Addition.id} value={Addition.id}>
                    {`${Addition.id} - ${Addition.invoiceDescription}`}
                </option>
            ))}
        </select>
    );
});

export default AdditionDropDown;
